import React from 'react';
import { renderFields } from '../../utils/RenderUtil.js';
/** renders a field group with 50 50 split */

var FieldGroup5050 = function FieldGroup5050(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "field-group-5050"
  }, renderFields(props, function (renderedChild, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "field-group-5050-col"
    }, renderedChild);
  }));
};

FieldGroup5050.displayName = "FieldGroup5050";
export { FieldGroup5050 };